import sx from 'utils/createSx';

export default sx({
  drawerPaper: {
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    py: 2,
    px: 2,
  },
  rootColumn: {
    height: '100%',
    minHeight: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 1,
    gap: 1,
  },
  titleTypography: {
    fontWeight: 600,
  },
  titleSpacer: {
    flex: 1,
  },
  bodyColumn: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
});
